const empty: string[] = []
const queryfy = (params: object) =>
	"?" +
	Object.entries(params)
	.reduce(
		(array, [key, value]) => [
			...array,
			encodeURIComponent(key) + "=" + encodeURIComponent(value),
		],
		empty,
	)
	.join("&")

export default queryfy
